import React from 'react';

const Action: React.FC = ({ children }) => (
  <div className="change-email-modal--action">{children}</div>
);

export default Action;
